import { CHAT_LISTING_OCCUPANTS, CHAT_LISTINGS, ChatListing, ChatListingOccupant } from "../../db/chat";
import { RealtimeDatabase as Database, RealtimeReference } from "../../db/common";
import { BaseDatabaseService } from "../DatabaseService";

/**
 * Shared Chat Listing Service
 * Works with both Firebase Admin SDK (backend) and Client SDK (frontend)
 */
export class ChatListingService extends BaseDatabaseService<ChatListing> {
    protected getBasePath(): string {
        return CHAT_LISTINGS;
    }

    //make it public for sub on change for FE
    public getEntityRef(listingId: string): RealtimeReference {
        return super.getEntityRef(listingId);
    }

    public occupantsService(listingId: string) {
        return new ChatListingOccupantsService(this.db, listingId);
    }
}

class ChatListingOccupantsService extends BaseDatabaseService<ChatListingOccupant> {
    constructor(protected db: Database, protected listingId: string) {
        super(db)
    }
    protected getBasePath(): string {
        return `${CHAT_LISTINGS}/${this.listingId}/${CHAT_LISTING_OCCUPANTS}`
    }
}